import Constants from '../../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}deheilige/`;

const title = "Holy Road - The holy Rachel";
const description = "The tomb of the matriarch Rachel lies in Bethlehem, but can only be reached from Israel. Is this biblical heartland, or the essence of colonial logic?";
const featuredImage = `${imageFolder}deheilige/omslag.jpg`;

export default [
    {
        type: "Meta",
        title: title,
        meta: [
            {"property": "og:title", "content": title},
            {"property": "og:url", "content": `${Constants.DOMAIN}${Constants.STORY_URL}deheilige`},
            {"property": "description", "content": ""},
            {"property": "og:description", "content": description},
            {"property": "og:image", "content": featuredImage},
            {"property": "twitter:card", "content": `summary_large_image`},
            {"property": "twitter:title", "content": title},
            {"property": "twitter:description", "content": description},
            {"property": "twitter:image", "content": featuredImage},
        ]
    },
    {
        type: "Quote",
        quote: description,
    },
    {
        type: "Paragraph",
        text: "Rachel and Jacob fell in love. Jacob had to work for fourteen years for his uncle - her father- to marry her. They had two children. Rachel died in childbirth when giving birth to her second son, Benjamin. She was buried in a humble tomb close to Bethlehem.  Route 60 runs along sanctuaries and ill-fated places. Since the fourth century AC, Rachel’s Tomb has been a place of pilgrimage for Jews, Christians and Muslims."
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}30__mobile.jpg`,
            tablet: `${imageFolder}30.jpg`,
            desktop: `${imageFolder}30.jpg`,
            alt: "",
            text: "Rachel’s Tomb, photographed somewhere between 1898 and 1946 by a photographer of the American Colony."
        }
    },
    {
        type: "Paragraph",
        text: "A camel caravan passes by a small stone building and in the background the unspoiled hills of Judea. This photograph from 1898 shows Rachel’s Tomb, important to all three Abrahamic religions, with its surrounding landscape that for centuries had remained untouched: the biblical heartland, situated between Jerusalem and Bethlehem. When this photograph was taken, only the building itself had been slightly expanded. The monument has been depicted in multiple paintings and sung about in poetry, such as in Nicholas Michel’s poem “Rachel’s Tomb”. The resulting picture of these cultural expressions, especially from the Jewish side, is that of a romanticized longing. "
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow1/01__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/01.jpg`,
                desktop: `${imageFolder}slideshow1/01.jpg`,
                alt: "",
                text: "Rachel’s Tomb, painted by the British artist Samuel Lawson Booth in 1900."
            },
            {
                mobile: `${imageFolder}slideshow1/02__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/02.jpg`,
                desktop: `${imageFolder}slideshow1/02.jpg`,
                alt: "",
                text: "Rachel’s Tomb photographed by a photographer of the American Colony somewhere between 1898 and 1914."
            },
            {
                mobile: `${imageFolder}slideshow1/03__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/03.jpg`,
                desktop: `${imageFolder}slideshow1/03.jpg`,
                alt: "",
                text: "These stamps depicting Rachel’s Tomb circulated in Palestine between 1927 and 1942 under the British mandate."
            },
            {
                mobile: `${imageFolder}slideshow1/04__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/04.jpg`,
                desktop: `${imageFolder}slideshow1/04.jpg`,
                alt: "",
                text: "Rachel’s Tomb in the 1930s (Photo by Matson Photoservice)."
            },
            {
                mobile: `${imageFolder}slideshow1/05__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/05.jpg`,
                desktop: `${imageFolder}slideshow1/05.jpg`,
                alt: "",
                text: "An old color photograph of Rachel’s Tomb, photographed by a photographer of the American Colony (year unknown)."
            },
            {
                mobile: `${imageFolder}slideshow1/06__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/06.jpg`,
                desktop: `${imageFolder}slideshow1/06.jpg`,
                alt: "",
                text: "British soldiers of a Scottish regiment controlling travelers on Route 60 in front of Rachel’s Tomb in the 1940s (Photo: American Colony)."
            },
            {
                mobile: `${imageFolder}slideshow1/07__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/07.jpg`,
                desktop: `${imageFolder}slideshow1/07.jpg`,
                alt: "",
                text: "Half of a Palestinian Pound with a depiction of Rachel’s Tomb. This currency, introduced in 1927 by the British, was used in the West Bank until 1950."
            },
            {
                mobile: `${imageFolder}slideshow1/08__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/08.jpg`,
                desktop: `${imageFolder}slideshow1/08.jpg`,
                alt: "",
                text: "Jewish women in front of Rachel’s Tomb in 1967 (Photo by Yosef Tamir)."
            },
            {
                mobile: `${imageFolder}slideshow1/09__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/09.jpg`,
                desktop: `${imageFolder}slideshow1/09.jpg`,
                alt: "",
                text: "Rachel’s Tomb in 1978."
            },
            {
                mobile: `${imageFolder}slideshow1/26__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/26.jpg`,
                desktop: `${imageFolder}slideshow1/26.jpg`,
                alt: "",
                text: "The present entry to Rachel’s Tomb."
            }
        ],
    },
    {
        type: "Paragraph",
        text: "Until deep into the nineteenth century there were not many Jews living in this territory, as only few people could travel to it under the Ottoman Empire rule.  At the end of the nineteenth and beginning of the twentieth century there were great Jewish immigration waves towards Palestine which consequently led to an increase of Jewish visitors to the grave. During the Arab-Israeli war of 1948 the monument became Jordanian property. For nineteen years the Jews could not visit it, which increased their desire towards it. This desire was fulfilled in 1967 when the Israeli occupation of the West Bank begun."
    },
    {
        type: "Paragraph",
        text: "Nowadays Rachel’s Tomb looks like this:"
    },
    {
        type: "Iframe",
        url: "https://player.vimeo.com/video/214016315",
        text: "On arrival at Rachel’s Tomb coming from Route 60."
    },
    {
        type: "Paragraph",
        text: "Those who wish to understand the Israeli occupation of the West Bank need to study Rachel’s Tomb. Religious interests, military power, and aesthetic manipulation are all visible in these few square meters. The fortification of this holy place represents, according to some, the essence of colonial logic. Still nowadays believers visit the grave. However, the religious experience has unmistakably acquired a power-political connotation. Jews now have the exclusive right to use this holy place and Rachel’s Tomb, lying at the center of Palestinian Bethlehem, has become a synagogue. A meters-high wall with military guard posts ensures its exclusivity."
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}28__mobile.jpg`,
            tablet: `${imageFolder}28.jpg`,
            desktop: `${imageFolder}28.jpg`,
            alt: "",
            text: "The military is always present inside the walls next to Rachel’s grave. The army uses the blue gate to access the Aida refugee camp."
        }
    },
    {
        type: "Paragraph",
        text: "After the Six-Day War in 1967 the grave fell into the hands of the Israeli rabbinate. However, during the Oslo Accords at the end of the 90s, the tomb was assigned to the Palestinian Authority, decision which caused great protests from right-wing nationalists and the ultra-orthodox Jewish side."
    },
    {
        type: "Paragraph",
        text: "Following this decision, Israel slightly pushed the boundaries so as to include the monument. As such, a holy place in the center of a Palestinian city came under Israeli authority. A settlement was founded and in 2001 the grave was re-annexed to Israel. An eight-meter high wall was built around the tomb, blocking the old road from Hebron through Bethlehem to Jerusalem. It is impossible for Palestinians to visit this place of pilgrimage, as Rachel’s Tomb is now only accessible for Jewish pilgrims and tourists."
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}01__mobile.jpg`,
            tablet: `${imageFolder}01.jpg`,
            desktop: `${imageFolder}01.jpg`,
            alt: "",
            text: "A view of the wall surrounding Rachel’s Tomb, as seen from Bethlehem."
        }
    },
    {
        type: "Paragraph",
        text: "The wall does not run along the Green Line, the border between Israel and the West Bank, but instead was for the most part it has been built kilometers deep into Palestinian territory. The wall also traces the bulge that Rachel's Tomb forms. Seen from above, the Israeli territory protrudes like an arm with a clenched fist into the city of Bethlehem. The grave can no longer be accessed from this city. For centuries Jerusalem and Bethlehem have been twin cities, intrinsically linked through Jesus’ birth in Bethlehem and violent death in Jerusalem. It was not until 2004 that the surgeons of the Israeli government succeeded in separating these Siamese twins from each other. "
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}27__mobile.jpg`,
            tablet: `${imageFolder}27.jpg`,
            desktop: `${imageFolder}27.jpg`,
            alt: "",
            text: "A complicated border situation arises around Rachel's Tomb (at the Star of David). The entire area on this map belongs to the West Bank occupied by Israel. Above the thick purple line lies East Jerusalem, beneath it is Bethlehem. The blue line is the boundary between the Israel-controlled Area C (above) and the Palestinian Area A (below). And then there is the red line: the separation wall that is wrapped around the monument."
        }
    },
    {
        type: "Paragraph",
        text: "The wall must guarantee that Jews can reach the matriarch´s grave from Jerusalem without obstacles. From Beitar Illit, an ultra-orthodox settlement in the West Bank, there is even a special bus line to this holy place. As such, it is well-visited. The funerary monument, a building from the Ottoman era, has separate entrances for men and women that lead to either side of the resting place: a concrete structure, protected with thick plastic to protect it against the palms, foreheads and lips of praying orthodox Jews."
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow2/15__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/15.jpg`,
                desktop: `${imageFolder}slideshow2/15.jpg`,
                alt: "",
                text: "Praying men at Rachel’s Tomb."
            },
            {
                mobile: `${imageFolder}slideshow2/16__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/16.jpg`,
                desktop: `${imageFolder}slideshow2/16.jpg`,
                alt: "",
                text: "Orthodox Jew praying at Rachel’s Tomb."
            },
            {
                mobile: `${imageFolder}slideshow2/17__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/17.jpg`,
                desktop: `${imageFolder}slideshow2/17.jpg`,
                alt: "",
                text: "A special Torah scroll at the men’s entrance of Rachel’s Tomb."
            },
            {
                mobile: `${imageFolder}slideshow2/18__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/18.jpg`,
                desktop: `${imageFolder}slideshow2/18.jpg`,
                alt: "",
                text: "Orthodox Jewish men at the men’s side of Rachel’s Tomb."
            },
            {
                mobile: `${imageFolder}slideshow2/19__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/19.jpg`,
                desktop: `${imageFolder}slideshow2/19.jpg`,
                alt: "",
                text: "Jewish men praying and studying the Torah at Rachel’s Tomb."
            },
            {
                mobile: `${imageFolder}slideshow2/20__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/20.jpg`,
                desktop: `${imageFolder}slideshow2/20.jpg`,
                alt: "",
                text: "Praying women at Rachel’s Tomb."
            },
            {
                mobile: `${imageFolder}slideshow2/21__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/21.jpg`,
                desktop: `${imageFolder}slideshow2/21.jpg`,
                alt: "",
                text: "Women kissing Rachel’s Tomb."
            },
            {
                mobile: `${imageFolder}slideshow2/22__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/22.jpg`,
                desktop: `${imageFolder}slideshow2/22.jpg`,
                alt: "",
                text: "Praying woman at Rachel’s Tomb."
            },
            {
                mobile: `${imageFolder}slideshow2/23__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/23.jpg`,
                desktop: `${imageFolder}slideshow2/23.jpg`,
                alt: "",
                text: "Jewish woman with prayer book at Rachel’s Tomb."
            },
            {
                mobile: `${imageFolder}slideshow2/24__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/24.jpg`,
                desktop: `${imageFolder}slideshow2/24.jpg`,
                alt: "",
                text: "Praying women at Rachel’s Tomb. In the background the curtain made from the wedding dress of Nava Applebaum, a twenty-year-old American-Israeli woman who died in a suicide attack in West Jerusalem on 9 September 2003, a day before her wedding."
            },
            {
                mobile: `${imageFolder}slideshow2/25__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/25.jpg`,
                desktop: `${imageFolder}slideshow2/25.jpg`,
                alt: "",
                text: "The men’s entrance of Rachel’s Tomb, where Route 60 used to be. "
            }
        ]
    },
    {
        type: "Paragraph",
        text: "Rachel’s Tomb is a symbol for the return of the Jews to Zion, their past homeland. At the tomb, Jewish women pray for fertility and safe delivery, a reference to Rachel, who remained infertile for a long time but whose prayers for a child were finally answered. A striking relic is the curtain draped over the Torah ark, the cabinet in which the five Torah scrolls are stored. This curtain is made from the wedding dress of Nava Applebaum, an American-Israeli woman aged twenty years when she died in a suicide attack in West Jerusalem,on 9 September 2003, one day before her wedding,."
    },
    {
        type: "Paragraph",
        text: "Surprisingly enough, the Jewish believers refer to the biblical matriarch as if she were their own mother. As Jewish tourist Shiffy Klein (20) from New York explains, who visits Rachel’s Tomb on her honeymoon explains: ‘With your mother you can be honest, be yourself, let your heart speak’. For this same reason Klein prefers this tomb over the Wailing Wall, eight kilometers to the north: ‘There are so many people there, it does not feel as intimate as here’."
    },
    {
        type: "Paragraph",
        text: "In accordance with the tradition, Klein has also prayed for fertility. ‘I said to Rachel: please help me to become a mother’. The fact that the monument is surrounded by walls is not a problem for her. ‘We also pray for a time in which walls will no longer be necessary. But when you are inside, with her, you feel safe’."
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}14__mobile.jpg`,
            tablet: `${imageFolder}14.jpg`,
            desktop: `${imageFolder}14.jpg`,
            alt: "",
            text: "Inside the enclosure and near Rachel's Tomb is a mural of the grave with a Bible passage from Genesis 35 verses 16-20 in which Rachel’s death and burial are described.  "
        }
    },
    {
        type: "Paragraph",
        text: "The safety of the orthodox Jews at the tomb has a price, paid by the Palestinians at the other side. There is a checkpoint between Jerusalem and Bethlehem. Some Palestinians may pass, for example those who have an Israeli ID card, or who have a permit to work at the Israeli side. For many other Palestinians the wall is an actual border. For them the other side, Israel, starts at the grave of the matriarch, even when there is no country in the world that recognizes this occupied area as Israeli territory."
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow3/02__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/02.jpg`,
                desktop: `${imageFolder}slideshow3/02.jpg`,
                alt: "",
                text: "The wall surrounding Rachel’s Tomb rising above the houses."
            },
            {
                mobile: `${imageFolder}slideshow3/03__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/03.jpg`,
                desktop: `${imageFolder}slideshow3/03.jpg`,
                alt: "",
                text: "Behind the wall is the road that leads to Rachel’s Tomb."
            },
            {
                mobile: `${imageFolder}slideshow3/04__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/04.jpg`,
                desktop: `${imageFolder}slideshow3/04.jpg`,
                alt: "",
                text: "The entrance to Rachel’s Tomb is visible from the other side of the wall."
            },
            {
                mobile: `${imageFolder}slideshow3/05__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/05.jpg`,
                desktop: `${imageFolder}slideshow3/05.jpg`,
                alt: "",
                text: "The military regularly uses the blue gate to raid the Aida refugee camp."
            },
            {
                mobile: `${imageFolder}slideshow3/06__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/06.jpg`,
                desktop: `${imageFolder}slideshow3/06.jpg`,
                alt: "",
                text: "The dome of Rachel’s Tomb is visible in the center of this photograph, taken from the cemetery in between Rachel’s grave and the Aida refugee camp."
            },
            {
                mobile: `${imageFolder}slideshow3/07__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/07.jpg`,
                desktop: `${imageFolder}slideshow3/07.jpg`,
                alt: "",
                text: "Due to the high wall the dome of Rachel’s Tomb is not visible from this point."
            },
            {
                mobile: `${imageFolder}slideshow3/08__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/08.jpg`,
                desktop: `${imageFolder}slideshow3/08.jpg`,
                alt: "",
                text: "Jewish settlers live here, next to Rachel’s Tomb but on the Palestinian side of the wall."
            },
            {
                mobile: `${imageFolder}slideshow3/09__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/09.jpg`,
                desktop: `${imageFolder}slideshow3/09.jpg`,
                alt: "",
                text: "The playground of the Wi’am organization."
            },
            {
                mobile: `${imageFolder}slideshow3/10__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/10.jpg`,
                desktop: `${imageFolder}slideshow3/10.jpg`,
                alt: "",
                text: "The wall passing over the land of the Wi’am organization due to which Nicola lost a quarter of its land."
            },
            {
                mobile: `${imageFolder}slideshow3/11__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/11.jpg`,
                desktop: `${imageFolder}slideshow3/11.jpg`,
                alt: "",
                text: "The blue gate is built on the old Route 60 which runs next to Rachel’s Tomb."
            },
            {
                mobile: `${imageFolder}slideshow3/12__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/12.jpg`,
                desktop: `${imageFolder}slideshow3/12.jpg`,
                alt: "",
                text: "Before the wall was built this gas station, right in front of Rachel’s Tomb, was one of the busiest gas stations of Bethlehem."
            },
            {
                mobile: `${imageFolder}slideshow3/13__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/13.jpg`,
                desktop: `${imageFolder}slideshow3/13.jpg`,
                alt: "",
                text: "The wall in direction of checkpoint 300, where Palestinians from the West Bank possessing a permit can travel to Jerusalem."
            }
        ],
    },
    {
        type: "Paragraph",
        text: "According to Usama Nicola, a Palestinian Christian from Bethlehem, he and his fellow believers also feel ‘emotionally connected’ to Rachel. ‘We would like to be able to enjoy the holy places in this area, especially Rachel’s Tomb’."
    },
    {
        type: "Paragraph",
        text: "Nicola works as a project coordinator at ‘Wi’am: The Palestinian Conflict Transformation Center’. Wi’am, says Nicola, invests in issues such as conflict mediation, women’s rights, and trauma counselling for children. When Rachel’s Tomb was walled, Wi’am lost a quarter of its land; Jewish settlers now live in the garden of the center, right next to the monument. A few times a year, sewage water coming from Rachel’s Tomb and going through a tunnel underneath the separation wall, flows into the garden of the Wi’am organization."
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}riool__mobile.jpg`,
            tablet: `${imageFolder}riool.jpg`,
            desktop: `${imageFolder}riool.jpg`,
            alt: "",
            text: "A few times a year, sewage water, coming from Rachel’s Tomb and going through a tunnel underneath the separation wall, flows into the garden of Wi’am: The Palestinian Conflict Transformation Center. Foto: Usama Nicola."
        }
    },
    {
        type: "Paragraph",
        text: "‘The wall’, he says, ‘is an ugly creation that disrupts the natural and man-made beauty of this country’. However, the biggest problem is that the wall denies Palestinians the access to Jerusalem and the rest of ‘historical Palestine’, as Nicola calls the entire country between the river Jordan and the Mediterranean sea."
    },
    {
        type: "Paragraph",
        text: "Thus, Rachel’s Tomb is no longer only the symbol of fertility, but also of the occupation of the West Bank. The biblical heartland has become the heart of the occupation."
    },
]


// WEBPACK FOOTER //
// ./src/data/stories/story3.js